// https://vuex.vuejs.org/en/state.html

export default {
  authStatus: '',
  token: localStorage.getItem('token') || '',
  expires_in: localStorage.getItem('expires_in'),
  user: JSON.parse(localStorage.getItem('userdata')),
  permissions: [], // will get from decode jwttoken in Parent Component
  notification: [],

  tableList: []
}
